/*global $, FG*/
/**
 * OTP step-up prompt.
 *
 * Drives #modal-otp (modal/otp_verify.twig) against the otp_request /
 * otp_verify endpoints. The endpoint base is 'user' on account pages and
 * 'guest' on the guest order-detail page — set via data-otp-base by the
 * page that includes the modal. On successful verification the page
 * reloads so the server re-renders with the gate satisfied (the resale
 * link only ever reaches the DOM after the session is verified).
 */
(function () {
    'use strict';

    // Every module in this directory reads the token into its own
    // function scope — the sibling `var CSRF_TOKEN` declarations never
    // reach `window`, so there is no shared global to inherit. utils.js
    // is loaded ahead of this file in layout.twig, and the meta tag it
    // reads is emitted in <head>, so the value is available at parse time.
    var CSRF_TOKEN = FG.Utils.getToken();

    /**
     * Translate a literal, falling back to the literal itself.
     *
     * Sibling modules call window.FGTLibs.i18n.t() bare, which is safe for them
     * because the bundle is always loaded by the time a click handler fires.
     * It is not safe HERE: one of the two call sites below is the ajax failure
     * handler, so a missing or broken bundle would throw *inside the error
     * path* and the fan would get a modal that silently does nothing instead of
     * a message. Degrade to English rather than to nothing.
     *
     * @param {string} literal
     * @return {string}
     */
    function _t(literal) {
        if (window.FGTLibs && window.FGTLibs.i18n && typeof window.FGTLibs.i18n.t === 'function') {
            return window.FGTLibs.i18n.t(literal);
        }

        return literal;
    }

    FG.Otp = {

        /**
         * Open the OTP modal for a purpose ('email_change' | 'resale').
         * @param {string} purpose
         * @param {function=} onVerified Called instead of the default
         *                    page reload when verification succeeds.
         */
        prompt: function (purpose, onVerified) {
            var $modal = $('#modal-otp');

            if (!$modal.length) {
                return;
            }

            $modal.data('otp-purpose', purpose);
            $modal.data('otp-onverified', onVerified || null);

            $('#otp-send-step').removeClass('hidden');
            $('#otp-code-step').addClass('hidden');
            $('#otp-error, #otp-success').addClass('hidden').text('');
            $('#otp-code-input').val('');

            // A prompt that opens after an aborted cycle must not inherit its
            // disabled buttons, or the modal renders permanently unusable.
            this._setBusy(false);

            $modal.modal({ show: true, backdrop: true, keyboard: true });
        },

        /**
         * Enable/disable the modal's action buttons.
         *
         * Guards against a second post while one is in flight. Two otp_verify
         * posts carrying the same code are actively harmful, not merely
         * wasteful: the first consumes the pending state, so the second comes
         * back 'no_pending_code', paints "that code is incorrect" over a
         * verification that actually SUCCEEDED, and writes a spurious
         * OtpFailed row — noise that reads as an attack in the very dashboards
         * this feature feeds.
         *
         * @param {boolean} isBusy
         */
        _setBusy: function (isBusy) {
            $('#btn-otp-send, #btn-otp-resend, #btn-otp-verify').prop('disabled', isBusy);
        },

        _post: function (resource, data, onSuccess) {
            var $modal = $('#modal-otp'),
                base = $modal.data('otp-base') || 'user',
                Ajax = new FG.Ajax(base + '/' + resource);

            data.csrf_token = CSRF_TOKEN;

            FG.Otp._setBusy(true);

            Ajax.setRequestData(data);
            Ajax.setSuccessCallback(function (FGResponse) {
                // Re-enabled before the handler runs, because a handler may
                // reload the page or hand off to a caller and never return.
                FG.Otp._setBusy(false);
                onSuccess(FGResponse);
            });
            Ajax.setFailureCallback(function (FGResponse) {
                FG.Otp._setBusy(false);
                $('#otp-error')
                    .text((FGResponse && FGResponse.msg) || _t('Something went wrong. Please try again.'))
                    .removeClass('hidden');
            });
            Ajax.send();
        },

        send: function () {
            var $modal = $('#modal-otp');

            $('#otp-error').addClass('hidden').text('');

            // A resend issues a NEW code, which invalidates whatever is already
            // typed. Leaving the stale value in place invites verifying the
            // superseded code and burning an attempt on it.
            $('#otp-code-input').val('');

            this._post('otp_request', { purpose: $modal.data('otp-purpose') }, function (FGResponse) {
                var data = FGResponse.data || {};

                if (data.otpRequired === false) {
                    // Gate inactive (flag off / infra fail-open): behave
                    // as verified.
                    FG.Otp._finish($modal);
                    return;
                }

                $('#otp-send-step').addClass('hidden');
                $('#otp-code-step').removeClass('hidden');
                $('#otp-success').text(FGResponse.msg || '').removeClass('hidden');
                $('#otp-code-input').focus();
            });
        },

        verify: function () {
            var $modal = $('#modal-otp'),
                code = $.trim($('#otp-code-input').val());

            if (!code) {
                $('#otp-error').text(_t('Please enter the code from your email.')).removeClass('hidden');
                return;
            }

            $('#otp-error').addClass('hidden').text('');

            this._post('otp_verify', {
                purpose: $modal.data('otp-purpose'),
                code: code
            }, function () {
                FG.Otp._finish($modal);
            });
        },

        _finish: function ($modal) {
            var onVerified = $modal.data('otp-onverified');

            $modal.modal('hide');

            if (typeof onVerified === 'function') {
                onVerified();
            } else {
                window.location.reload();
            }
        }
    };

    $(function () {
        $(document)
            .on('click', '#btn-otp-send, #btn-otp-resend', function (e) {
                e.preventDefault();
                FG.Otp.send();
            })
            .on('click', '#btn-otp-verify', function (e) {
                e.preventDefault();
                FG.Otp.verify();
            })
            .on('keydown', '#otp-code-input', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    FG.Otp.verify();
                }
            })
            // Verify-then-reveal resale gate: this button renders instead
            // of the thumbprint link until the session is verified.
            .on('click', '.btn-resale-otp', function (e) {
                e.preventDefault();
                FG.Otp.prompt('resale');
            });
    });
}());
